import SortSelect from './sort-select.component'

export default SortSelect
